"use client";

import { useSession } from "next-auth/react";
import { useReferral } from "@/components/providers/ReferralProvider";
import { X } from "lucide-react";

export function ReferralBanner() {
  const { status } = useSession();
  const { referrerName, isBannerDismissed, dismissBanner } = useReferral();

  // Only show to unauthenticated visitors who landed via a valid referral link and haven't dismissed the banner
  if (status !== "unauthenticated" || !referrerName || isBannerDismissed) {
    return null;
  }

  return (
    <div className="w-full bg-primary/10 border-b border-primary/20 backdrop-blur-md py-2 px-4 sticky top-0 z-50 transition-all duration-300">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex-1 text-center text-xs sm:text-sm font-medium text-foreground">
          <span>
            👋 You&apos;ve been referred by <strong className="text-primary">{referrerName}</strong>! Sign up today to start your 7-day trial of Hirecarta Pro. When you subscribe, they will be thanked with a free week!
          </span>
        </div>
        <button
          onClick={dismissBanner}
          className="text-muted-foreground hover:text-foreground p-1 rounded-full hover:bg-foreground/5 transition-colors shrink-0"
          aria-label="Dismiss referral banner"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
